import App from "../App";
import Environment from "./Environment";
import Sphere from "./Sphere";
import Floor from "./Floor";
var World = /** @class */ (function () {
    function World() {
        var _this = this;
        this.app = new App();
        this.scene = this.app.scene;
        this.resources = this.app.resources;
        this.environment = new Environment();
        this.resources.on("ready", function () {
            _this.sphere = new Sphere();
            _this.floor = new Floor();
            _this.environment.create();
            _this.floor.create();
            _this.sphere.create();
        });
    }
    World.prototype.update = function () {
        this.sphere && this.sphere.update();
    };
    return World;
}());
export default World;
